import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { VbrickPlayerModule } from '@vbrick/vbrick-player';

import { VideoPlayerAngularModule } from 'rev-shared/videoPlayer/VideoPlayerAngular.Module';

import { VbWebcastPlayerComponent } from './VbWebcastPlayer.Component';

const components = [
	VbWebcastPlayerComponent
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		CommonModule,
		TranslateModule,
		VbrickPlayerModule,
		VideoPlayerAngularModule
	]
})
export class VbWebcastPlayerModule {}
